/**
 * @fileoverview used for handling adding new lead field from dialog.
 * @author Naiqiao Liang (nliang@yext.com)
 */

goog.module('yext.developerapps.common.LeadField');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const DialogView = goog.require('yext.apps.common.DialogView');

/**
 * Constructor of LeadField
 *
 * @constructor
 */
const LeadField = function() {
  this.dialogView = new DialogView($('.js-dialog'));
  this.dialogView.init();

  this.$view = $('.js-lead-field');
  this.$fieldName = this.$view.find('.js-field-name');
  this.$fieldNameError = this.$view.find('.js-field-name-error');
  this.$fieldGroup = this.$view.find('.js-field-group');
  this.$fieldGroupError = this.$view.find('.js-field-group-error');
  this.$dialogError = this.$view.find('.js-dialog-error');

  this.url = this.$view.data('submit-url');
  this.source = undefined;

  this.init();
};

LeadField.prototype.init = function() {
  this.bindSubmit();
  this.bindFields();
};

LeadField.prototype.bindFields = function() {
  var self = this;
  self.$fieldName.on('input', function() {
    self.toggleFieldNameError('');
  });
  self.$fieldGroup.on('change', function() {
    self.toggleFieldGroupError('');
  });
};

LeadField.prototype.toggleFieldNameError = function(error) {
  if (error === '') {
    this.$fieldNameError.slideUp('fast');
  } else {
    this.$fieldNameError.text(error).slideDown('fast');
  }
  this.$fieldName.toggleClass('error', error !== '');
};

LeadField.prototype.toggleFieldGroupError = function(error) {
  if (error === '') {
    this.$fieldGroupError.slideUp('fast');
  } else {
    this.$fieldGroupError.text(error).slideDown('fast');
  }
  this.$fieldGroup.toggleClass('error', error !== '');
};

LeadField.prototype.toggleDialogViewError = function(error) {
  if (error === '') {
    this.$dialogError.slideUp('fast');
  } else {
    this.$dialogError.text(error).slideDown('fast');
  }
};

LeadField.prototype.bindSubmit = function() {
  var leadField = this;
  leadField.$view.find('.js-new-field-submit').on('click', function() {
    leadField.submit();
  });
};

LeadField.prototype.submit = function() {
  var leadField = this;
  var $fieldSubmit = leadField.$view.find('.js-new-field-submit');
  var input = {
    'fieldName': leadField.$fieldName.val(),
    'fieldGroup': leadField.$fieldGroup.val(),
  };

  $fieldSubmit.prop('disabled', true);

  if (this.formValidated()) {
    $.ajax({
      method: 'POST',
      ContentType: 'application/json',
      data: input,
      url: leadField.url,
    })
      .done(function(data) {
        if (data['error']) {
          leadField.toggleDialogViewError(data['error']);
          return;
        }

        var newField = undefined;

        for (var i = 0; i < data.length; i ++) {
          if (data[i].label === input['fieldName']) {
            newField = data[i];
            break;
          }
        }

        $(leadField).trigger(
          'submitted', // message to broadcast to leadGen view
          {
            'totalFields': data, // total fields after adding new one, which is sorted already
            'newField': newField, // new field
            'source': leadField.source, // dropdown name
          });
        leadField.hide();
      })
      .fail(function(jqXHR, textStatus) {
        leadField.toggleDialogViewError(yext.msg('Failed to save new field'));
      })
      .always(function() {
        $fieldSubmit.prop('disabled', false);
      });
  } else {
    leadField.toggleDialogViewError('');
    $fieldSubmit.prop('disabled', false);
  }
};

/**
 * formValidated checks if any required fields are missing
 */
LeadField.prototype.formValidated = function() {
  var formValidated = true;
  if (this.$fieldName.val() === '') {
    this.toggleFieldNameError(yext.msg('Field Name cannot be empty'));
    formValidated = false;
  }
  if (this.$fieldGroup.val() === '') {
    this.toggleFieldGroupError(yext.msg('A Property Group must be selected'));
    formValidated = false;
  }
  return formValidated;
};


LeadField.prototype.show = function(source) {
  this.$fieldName.val('').removeClass('error');
  this.$fieldGroup.val('').removeClass('error');
  this.$fieldNameError.hide();
  this.$fieldGroupError.hide();
  this.$dialogError.hide();
  this.dialogView.show();
  this.source = source;
};

LeadField.prototype.hide = function() {
  this.dialogView.hide();
  this.source = undefined;
};

exports = LeadField;
